/** Browser mode, normalized once by instanceMode.ts in the Vite config. */
// Shared Vue views use `IS_COSMOS === true` for template-facing aliases. A
// direct alias is compiled with unref(), preventing build-time branch removal.
export const IS_COSMOS = import.meta.env.VITE_INSTANCE_MODE === 'cosmos'

/** Keep each shell and its styles in its own build, as apps/app does at startup. */
export function loadAuthRoot() {
  if (import.meta.env.VITE_INSTANCE_MODE === 'cosmos') return import('../App.vue')
  return import('../WorkApp.vue')
}
